var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.publisherId===29)?_c('dong-jiao-component',{ref:"dongjiao"}):_c('resource-svg-component',{ref:"resourceSvg"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }